const STAFF_ROLES = ['ADMIN', 'COLABORADOR', 'SUPER_COLABORADOR'];

export const LEGACY_F29_MODULE_ID = 'f29';

export function hasInternalTeamRole(roles) {
  return (roles || []).some((r) => STAFF_ROLES.includes(r));
}

export function defaultStaffModuleAccess(roles) {
  return hasInternalTeamRole(roles);
}

function findModulePermission(permissions, moduleId, legacyModuleIds = []) {
  const list = Array.isArray(permissions) ? permissions : [];
  const direct = list.find((p) => p.moduleId === moduleId);
  if (direct?.hasAccess === true || direct?.hasAccess === false) return direct;
  for (const legacyId of legacyModuleIds) {
    const legacy = list.find((p) => p.moduleId === legacyId);
    if (legacy?.hasAccess === true || legacy?.hasAccess === false) return legacy;
  }
  return direct;
}

/**
 * Jerarquía: bloqueo empresa → usuario×empresa → usuario → default por rol staff.
 */
export function resolveStaffModuleAccess(
  moduleId,
  userPerms,
  companyPerms,
  userCompanyPerms,
  roles,
  legacyModuleIds = [],
) {
  const companyPerm = findModulePermission(companyPerms, moduleId, legacyModuleIds);
  if (companyPerm?.hasAccess === false) return false;

  const userCompanyPerm = findModulePermission(userCompanyPerms, moduleId, legacyModuleIds);
  if (userCompanyPerm?.hasAccess === true) return true;
  if (userCompanyPerm?.hasAccess === false) return false;

  const userPerm = findModulePermission(userPerms, moduleId, legacyModuleIds);
  if (userPerm?.hasAccess === true) return true;
  if (userPerm?.hasAccess === false) return false;

  return defaultStaffModuleAccess(roles);
}
